// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"321":"4fc77022","526":"4fc77022","531":"4fc77022","983":"744f416e"}[chunkId] + ".chunk.css";
};